import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from './common';

const routes = [
    {
        matchRegex: '/QuoteTemplate/Detail',
        name: 'Quote Template - Detail',
        slots: [
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_SECTION,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quote-price-material', label: 'Quote Price - Material Line' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { 
                    key: 'MARKETPLACE_EVENT_AFTER_SAVE_COST_LINE_SUCCESS', 
                    label: 'After save cost line success' 
                },
                { 
                    key: 'MARKETPLACE_EVENT_AFTER_DELETE_COST_LINE_SUCCESS', 
                    label: 'After delete cost line success' 
                },
                {
                    key: 'MARKETPLACE_EVENT_AFTER_CLONE_QUOTE_SECTION_SUCCESS',
                    label: 'After clone quote section success',
                },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quantity-cost-elements', label: 'Material Cost Quantity Elements' },
            ],
        },
    },
]
export default routes;